import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState } from "./campaignDetailers.initial-state";
import {
  fetchCampaignByShort,
  validateShortId,
  updateCampaign,
} from "./campaignDetails.actions";
import { CampaignDetails } from "./campaignDetails.types";

const campaignDetailsSlice = createSlice({
  name: "campaignDetails",
  initialState,
  reducers: {
    setCampaignDetails: (state, action: PayloadAction<CampaignDetails>) => {
      state.data = {...action.payload};
    },
    resetUpdateSuccess: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Campaign Details
      .addCase(fetchCampaignByShort.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCampaignByShort.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(fetchCampaignByShort.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch campaign";
      })
      // Validation
      .addCase(validateShortId.pending, (state) => {
        state.shortIdValidation = { valid: null, message: "Checking..." };
      })
      .addCase(validateShortId.fulfilled, (state, action) => {
        state.shortIdValidation = {
          valid: action.payload.valid,
          message: action.payload.message,
        };
      })
      .addCase(validateShortId.rejected, (state) => {
        state.shortIdValidation = {
          valid: false,
          message: "Server error. Try again.",
        };
      })
      .addCase(updateCampaign.fulfilled, (state, action) => {
      state.loading = false;
      state.updateSuccess = true;
    })
    .addCase(updateCampaign.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.updateSuccess = false;
    })
    .addCase(updateCampaign.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
      state.updateSuccess = false;
    });
  },
});

export const { setCampaignDetails, resetUpdateSuccess } = campaignDetailsSlice.actions;
const campaignDetailsReducer = campaignDetailsSlice.reducer;
export default campaignDetailsReducer;

